import React, { useState, useEffect } from 'react';
import STRINGS from '../globals/strings';
import IMAGES from '../globals/images';
import MarqueeText from '../components/MarqueeText.tsx';
import YetBat from '../components/YetBat';
import NoYetData from '../components/noYetData.jsx';
import '../styles/crick.css';

const LiveScorecard = ({ matchData, activeLink, handleLinkClick, formatOutInfo, openPopup, openBatsmanPopup, activeTab, selectedTeam, setSelectedTeam, matchSettings }) => {

  const getDisplayRuns = (ball) => {
    if (!matchSettings) return ball.runs
    if (ball.is_wide_ball && matchSettings.is_wide_ball_allowed === 1 && ball.runs > 0) return ball.runs - 1
    if (ball.is_no_ball && matchSettings.is_no_ball_allowed === 1 && ball.runs > 0) return ball.runs - 1
    return ball.runs
  }

  const getTeamImageUrl = (matchData) => {
    const teamImage = matchData.team?.team_image;
    const teamName = matchData.team?.team_name;
    if (teamImage && teamImage.charAt(teamImage.length - 1) === '/') {
      return teamName ? `${teamImage}${teamName.replace(/\s+/g, '_')}` : IMAGES.PHOENIX_LOGO;
    }
    return teamImage || IMAGES.PHOENIX_LOGO;
  };

  if (!matchData) {
    return <div>Loading match data...</div>;
  }

  const isSecondTeamYetToBat = !matchData.team2?.inning_total?.overs || matchData.team2?.inning_total?.overs === 0;
  const isSecondTeamSelected = selectedTeam === matchData.team2?.team_name;

  return (
    <div>
      <div className={`team-row ${activeTab === 'Summary' ? 'hide-team' : ''}`} style={{ cursor: activeTab === 'Summary' ? 'default' : 'pointer' }}>
        <div
          className={`team ${matchData.team2?.result && matchData.team2?.result.winning_team === matchData.team1?.team_name && activeTab === 'Summary' ? 'gif-bg' : ''} ${selectedTeam === matchData.team1?.team_name && activeTab !== 'Summary' ? 'selected-team' : ''}`}
          style={{ borderRadius: '20px 0 0 20px', pointerEvents: activeTab === 'Summary' ? 'none' : 'all', cursor: activeTab === 'Summary' ? 'default' : 'pointer' }}
          onClick={() => setSelectedTeam(matchData.team1?.team_name)}
        >
          <img
            src={getTeamImageUrl(matchData.team1.team_image)}
            onError={(e) => {
              e.target.src = IMAGES.PHOENIX_LOGO;
            }}
            alt={STRINGS.TEAM1_LOGO_ALT}
            className="team-logo"
          />
          <div
            className="team-content"
            style={{ cursor: activeTab === 'Summary' ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
          >
            <div>
              <label className="team-name" style={{ cursor: activeTab === 'Summary' ? 'default' : 'pointer' }}>
                {matchData.team1?.team_name}
              </label>
              <span style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <label
                  className="team-score"
                  style={{
                    cursor: activeTab === 'Summary' ? 'default' : 'pointer',
                    color: matchData.team2?.result && matchData.team2?.result.winning_team === matchData.team1?.team_name && activeTab === 'Summary' ? '#3747DE' : '',
                  }}
                >
                  {`${matchData.team1?.inning_total?.total_runs}-${matchData.team1?.inning_total?.total_wickets}`}
                </label>
                <label className="team-over" style={{ cursor: activeTab === 'Summary' ? 'default' : 'pointer' }}>
                  ({matchData.team1?.inning_total?.overs}/{matchData.team1?.inning_total?.match_overs})
                </label>
              </span>
            </div>
            <div className="dropdown-area">
              {activeTab === 'Scorecard' && (
                <button
                  className={`dropdown-button ${selectedTeam === matchData.team1?.team_name ? 'active' : ''}`}
                  onClick={() => setSelectedTeam(matchData.team1?.team_name)}
                >
                  <img src={selectedTeam === matchData.team1?.team_name ? IMAGES.VECTOR_UP : IMAGES.VECTOR_DOWN} alt={STRINGS.DROPDOWN_ALT} />
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className={`team ${matchData.team2?.result && matchData.team2?.result.winning_team === matchData.team2?.team_name && activeTab === 'Summary' ? 'gif-bg' : ''} ${selectedTeam === matchData.team2?.team_name && activeTab !== 'Summary' ? 'selected-team' : ''}`}
          style={{ textAlign: 'right', borderRadius: '0 20px 20px 0', pointerEvents: activeTab === 'Summary' ? 'none' : 'all' }}
          onClick={() => setSelectedTeam(matchData.team2?.team_name)}
        >
          <img
            src={getTeamImageUrl(matchData.team2.team_image)}
            onError={(e) => {
              e.target.src = IMAGES.PHOENIX_LOGO;
            }}
            alt={STRINGS.TEAM2_LOGO_ALT}
            className="team-logo"
            style={{ marginRight: '0' }}
          />
          <div
            className="team-content"
            style={{ cursor: activeTab === 'Summary' ? 'default' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
          >
            <div className="dropdown-area">
              {activeTab === 'Scorecard' && (
                <button
                  className={`dropdown-button ${selectedTeam === matchData.team2?.team_name ? 'active' : ''}`}
                  onClick={() => setSelectedTeam(matchData.team2?.team_name)}
                >
                  <img src={selectedTeam === matchData.team2?.team_name ? IMAGES.VECTOR_UP : IMAGES.VECTOR_DOWN} alt={STRINGS.DROPDOWN_ALT} />
                </button>
              )}
            </div>
            <div>
              <label className="team-name" style={{ cursor: 'pointer', justifyContent: 'flex-end' }}>
                {matchData.team2?.team_name?.trim()}
              </label>
              <span style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                {matchData.team2?.inning_total.overs ? (
                  <>
                    <label className="team-score" style={{ cursor: 'pointer' }}>
                      {`${matchData.team2.inning_total.total_runs}-${matchData.team2.inning_total.total_wickets}`}
                    </label>
                    <label className="team-over" style={{ cursor: 'pointer' }}>
                      ({matchData.team2.inning_total.overs}/{matchData.team2.inning_total.match_overs})
                    </label>
                  </>
                ) : (
                  <label className="team-over" style={{ cursor: 'pointer', lineHeight: '2.1' }}>
                    Yet to bat...
                  </label>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>

      {matchData?.team1?.inning_total?.is_new_target === 1 && (
        <div className="alibag">
          <div className="target">
            <label className="target-label">
              <span dangerouslySetInnerHTML={{
                __html: STRINGS.TARGET_LABEL(
                  matchData.team1.team_name,
                  matchData.team1.inning_total.total_runs,
                  matchData.team2.team_name,
                  matchData.team1.inning_total.new_target
                )
              }} />
            </label>
          </div>
        </div>
      )}

      <div className="scorecard" style={{ marginTop: "20px" }}>
        {isSecondTeamYetToBat && isSecondTeamSelected ? (
          <YetBat teamName={matchData.team2.team_name} />
        ) : (
          <>
            <div className="scorecard-tabs-section">
              <ul className="scorecard-tabs">
                <li
                  className={`scorecard-link${activeLink === "Betting" ? " active" : ""}`}
                  onClick={(e) => handleLinkClick("Betting", e)}
                >
                  {STRINGS.BETTING_LINK}
                </li>
                <li
                  className={`scorecard-link${activeLink === "Bowling" ? " active" : ""}`}
                  onClick={(e) => handleLinkClick("Bowling", e)}
                >
                  {STRINGS.BOWLING_LINK}
                </li>
                <li
                  className={`scorecard-link${activeLink === "Fall of Wicket" ? " active" : ""}`}
                  onClick={(e) => handleLinkClick("Fall of Wicket", e)}
                >
                  {STRINGS.FALL_OF_WICKET_LINK}
                </li>
                <li
                  className={`scorecard-link${activeLink === "Partnership" ? " active" : ""}`}
                  onClick={(e) => handleLinkClick("Partnership", e)}
                >
                  {STRINGS.PARTNERSHIPS_LINK}
                </li>
                <li
                  className={`scorecard-link${activeLink === "Overs" ? " active" : ""}`}
                  onClick={(e) => handleLinkClick("Overs", e)}
                >
                  {STRINGS.OVERS_LINK}
                </li>
              </ul>
            </div>

            {activeLink === "Betting" && (
              (selectedTeam === matchData.team1?.team_name ? matchData.team1?.batting : matchData.team2?.batting)?.length > 0 ? (
                <>
                  <table className="scorecard-betting">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>{STRINGS.BATSMAN_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.RUNS_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.BALLS_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.FOURS_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.SIXES_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.STRIKE_RATE_HEADER}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(selectedTeam === matchData.team1?.team_name ? matchData.team1?.batting : matchData.team2?.batting)?.map((player, index) => (
                        <tr key={index}>
                          <td className="name" onClick={() => openBatsmanPopup(player)} style={{ cursor: "pointer", textAlign: "left" }}>{player?.batsman_name}{player?.is_not_out === 1 ? "*" : ""}<small style={{ fontSize: "14px", fontWeight: "500" }}>{formatOutInfo(player)}</small></td>
                          <td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{player?.total_runs}</td>
                          <td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{player?.total_balls}</td>
                          <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{player?.total_fours}</td>
                          <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{player?.total_sixes}</td>
                          <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{player?.strike_rate?.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="extra-section">
                    <label className="extra">{STRINGS.EXTRA_LABEL}</label>
                    <label className="ten">{selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.total || 0 : matchData.team2.inning_total.extra?.total || 0}</label>
                    <label className="extra-details">{STRINGS.EXTRA_DETAILS(
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.bye || 0 : matchData.team2.inning_total.extra?.bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.leg_bye || 0 : matchData.team2.inning_total.extra?.leg_bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.wide_ball || 0 : matchData.team2.inning_total.extra?.wide_ball || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.no_ball || 0 : matchData.team2.inning_total.extra?.no_ball || 0
                    )}</label>
                  </div>
                </>
              ) : (
                <NoYetData tableName={STRINGS.BETTING_LINK} />
              )
            )}

            {activeLink === "Bowling" && (
              (selectedTeam === matchData.team1.team_name ? matchData.team1.bowling : matchData.team2.bowling).length > 0 ? (
                <>
                  <table className="scorecard-bowling">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>{STRINGS.BOWLER_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.OVERS_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.MAIDENS_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.RUNS_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.WICKETS_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.ECONOMY_HEADER}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(selectedTeam === matchData.team1.team_name ? matchData.team1.bowling : matchData.team2.bowling).map((player, index) => {
                        return (
                          <tr key={index}>
                            <td className="name" onClick={() => openPopup(player)} style={{ cursor: "pointer", textAlign: "left" }}>{player.bowler_name}<img src={IMAGES.VECTOR2} alt={STRINGS.BOWLER_DROPDOWN_ALT} className="bowler-dropdown" onClick={() => openPopup(player)} /></td>
                            <td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{player?.total_over}</td>
                            <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{player?.total_maiden_over}</td>
                            <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{player?.total_run}</td>
                            <td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{player?.total_wicket}</td>
                            <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{player?.economy?.toFixed(2)}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  <div className="extra-section">
                    <label className="extra">{STRINGS.EXTRA_LABEL}</label>
                    <label className="ten">{selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.total || 0 : matchData.team2.inning_total.extra?.total || 0}</label>
                    <label className="extra-details">{STRINGS.EXTRA_DETAILS(
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.bye || 0 : matchData.team2.inning_total.extra?.bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.leg_bye || 0 : matchData.team2.inning_total.extra?.leg_bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.wide_ball || 0 : matchData.team2.inning_total.extra?.wide_ball || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.no_ball || 0 : matchData.team2.inning_total.extra?.no_ball || 0
                    )}</label>
                  </div>
                </>
              ) : (
                <NoYetData tableName={STRINGS.BOWLING_LINK} />
              )
            )}

            {activeLink === "Fall of Wicket" && (
              ((selectedTeam === matchData.team1.team_name ? matchData.team1.fall_of_wicket : matchData.team2.fall_of_wicket) || []).length > 0 ? (
                <>
                  <table className="scorecard-fall-of-wicket">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>{STRINGS.BATSMAN_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.SCORE_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.OVER_HEADER}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {((selectedTeam === matchData.team1.team_name ? matchData.team1.fall_of_wicket : matchData.team2.fall_of_wicket) || []).map((wicket, index) => (
                        <tr key={index}>
                          <td className="name" style={{ textAlign: "left" }}>{wicket.out_player_name}</td>
                          <td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{`${wicket.total_runs}/${wicket.total_wicket}`}</td>
                          <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{wicket.over_couter}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="extra-section">
                    <label className="extra">{STRINGS.EXTRA_LABEL}</label>
                    <label className="ten">{selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.total || 0 : matchData.team2.inning_total.extra?.total || 0}</label>
                    <label className="extra-details">{STRINGS.EXTRA_DETAILS(
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.bye || 0 : matchData.team2.inning_total.extra?.bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.leg_bye || 0 : matchData.team2.inning_total.extra?.leg_bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.wide_ball || 0 : matchData.team2.inning_total.extra?.wide_ball || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.no_ball || 0 : matchData.team2.inning_total.extra?.no_ball || 0
                    )}</label>
                  </div>
                </>
              ) : (
                <NoYetData tableName={STRINGS.FALL_OF_WICKET_LINK} />
              )
            )}

            {activeLink === "Partnership" && (
              ((selectedTeam === matchData.team1.team_name ? matchData.team1.partnership : matchData.team2.partnership) || []).length > 0 ? (
                <>
                  <table className="scorecard-partnership">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>{STRINGS.BATSMAN_HEADER} 1</th>
                        <th style={{ textAlign: "left" }}>{STRINGS.BATSMAN_HEADER} 2</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.EXTRA_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.SCORE_HEADER}</th>
                        <th style={{ textAlign: "right" }}>{STRINGS.BALL_HEADER}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {((selectedTeam === matchData.team1.team_name ? matchData.team1.partnership : matchData.team2.partnership) || []).map((partner, index) => (
                        <tr key={index}>
                          <td className="name" style={{ textAlign: "left" }}>{partner.batsman_1_name}<br /><span style={{ fontSize: "12px", fontWeight: "500" }}>{partner.batsman_1_total_run}</span><span style={{ fontSize: "12px", fontWeight: "500" }}> ({partner.batsman_1_total_ball})</span></td>
                          <td className="name" style={{ textAlign: "left" }}>{partner.batsman_2_name}<br /><span style={{ fontSize: "12px", fontWeight: "500" }}>{partner.batsman_2_total_run}</span><span style={{ fontSize: "12px", fontWeight: "500" }}> ({partner.batsman_2_total_ball})</span></td>
                          <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{partner.extra}</td>
                          <td style={{ textAlign: "right", color: "#030311", fontSize: "16px", fontWeight: "500" }}>{partner.score}</td>
                          <td style={{ textAlign: "right", color: "#717171", fontSize: "16px", fontWeight: "500" }}>{partner.ball}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="extra-section">
                    <label className="extra">{STRINGS.EXTRA_LABEL}</label>
                    <label className="ten">{selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.total || 0 : matchData.team2.inning_total.extra?.total || 0}</label>
                    <label className="extra-details">{STRINGS.EXTRA_DETAILS(
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.bye || 0 : matchData.team2.inning_total.extra?.bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.leg_bye || 0 : matchData.team2.inning_total.extra?.leg_bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.wide_ball || 0 : matchData.team2.inning_total.extra?.wide_ball || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.no_ball || 0 : matchData.team2.inning_total.extra?.no_ball || 0
                    )}</label>
                  </div>
                </>
              ) : (
                <NoYetData tableName={STRINGS.PARTNERSHIPS_LINK} />
              )
            )}

            {activeLink === "Overs" && (
              ((selectedTeam === matchData.team1.team_name ? matchData.team1.over_history : matchData.team2.over_history) || []).length > 0 ? (
                <>
                  <div className="overs-container">
                    {(selectedTeam === matchData.team1.team_name ? matchData.team1.over_history : matchData.team2.over_history).map((over, index) => (
                      <div key={index} className="over-box">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <label className="wicket-score">
                            {STRINGS.WICKET_SCORE(over.over_number, over.total_run_from_over)}
                          </label>
                          <label className="bowler-info">
                            <MarqueeText text={`${over?.bowler_name} to ${over?.batsmans_list}`} />
                          </label>
                        </div>
                        <div className="dots-container">
                          {over.ball_history.map((ball, ballIndex) => {
                            let displayRun = getDisplayRuns(ball)

                            const isSpecial = ball.is_wide_ball || ball.is_no_ball || ball.is_bye || ball.is_leg_bye

                            const fmt = (runs, type) => runs > 0 ? `${runs}${type}` : type


                            const labels = []
                            if (ball.is_wide_ball) labels.push(fmt(ball.is_out ? displayRun : 0, "WD"))
                            else if (ball.is_no_ball) labels.push(fmt(ball.is_out ? displayRun : 0, "NB"))
                            else if (ball.is_bye) labels.push(fmt(ball.is_out ? displayRun : 0, "BYE"))
                            else if (ball.is_leg_bye) labels.push(fmt(ball.is_out ? displayRun : 0, "LB"))

                            if (ball.is_out && labels.length === 0) labels.push(fmt(displayRun, "WK"))

                            return (
                              <div key={ballIndex} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <span className={ball.is_out ? "dot redin" : (ball.is_four || ball.is_six) ? "dot gilin" : "dot back"}>
                                  {isSpecial && ball.is_out ? "W" : displayRun}
                                </span>
                                {labels.length > 0 && (
                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "5px", gap: "1px" }}>
                                    {labels.map((label, i) => (
                                      <span key={i} style={{ fontWeight: "500", fontSize: "12px", lineHeight: "14px", textAlign: "center", color: "#717171", whiteSpace: "nowrap" }}>
                                        {label}
                                      </span>
                                    ))}
                                  </div>
                                )}
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="extra-section">
                    <label className="extra">{STRINGS.EXTRA_LABEL}</label>
                    <label className="ten">{selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.total || 0 : matchData.team2.inning_total.extra?.total || 0}</label>
                    <label className="extra-details">{STRINGS.EXTRA_DETAILS(
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.bye || 0 : matchData.team2.inning_total.extra?.bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.leg_bye || 0 : matchData.team2.inning_total.extra?.leg_bye || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.wide_ball || 0 : matchData.team2.inning_total.extra?.wide_ball || 0,
                      selectedTeam === matchData.team1.team_name ? matchData.team1.inning_total.extra?.no_ball || 0 : matchData.team2.inning_total.extra?.no_ball || 0
                    )}</label>
                  </div>
                </>
              ) : (
                <NoYetData tableName={STRINGS.OVERS_LINK} />
              )
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default LiveScorecard